<h2 class="contact-title font-14">{{ contact.name }}</h2>
<app-contact-link [phone]="contact.phone"></app-contact-link>
<app-contact-link [email]="contact.email"></app-contact-link>
